export default __webpack_public_path__ + "static/media/add.31b8e42f.ico";